import InfoIcon from "@mui/icons-material/Info";
import { TooltipMU } from "app/components/tooltip/TooltipMU";
import { isSistemaOperacionalWindows } from "app/utils/isSistemaOperacionalWindows";
import clsx from "clsx";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { PaginaPesquisaProdutoContext } from "../pagina-pesquisa-produto/PaginaPesquisaProduto";
import { TableHeadPesquisaProdutos } from "./Headers/TableHeadPesquisaProdutos";
import {
  ItemPesquisaProduto,
} from "./TBody/ItemPesquisaProduto";

const estilosTabelas = require("../../../estilos/tabelas.module.scss").default;
import { fonteGradeOuHerdada } from 'app/utils/tamanhoFonteGrid'

// 491123 — mantém apenas UM dropdown de Ações (Inserir Novo/Incrementar Quantidade) aberto por
// vez entre todas as linhas: abrir o de uma nova linha fecha automaticamente o de outra, já que
// o estado é compartilhado (código do produto com o dropdown aberto), não local a cada linha.
export type DropdownAcoesRepetidoContextType = {
  codigoProdutoComDropdownAberto: string | null;
  setCodigoProdutoComDropdownAberto: React.Dispatch<React.SetStateAction<string | null>>;
};

export const DropdownAcoesRepetidoContext = React.createContext<DropdownAcoesRepetidoContextType>({
  codigoProdutoComDropdownAberto: null,
  setCodigoProdutoComDropdownAberto: () => { },
});

const GridItensPesquisaProdutos = () => {
  const contexto = useContext(PaginaPesquisaProdutoContext)
  const [codigoProdutoComDropdownAberto, setCodigoProdutoComDropdownAberto] = useState<string | null>(null);
  //const exibirColunaQuantidade = contexto.chamadoParaInserirProdutoNoOrcamento && !contexto.pesquisandoApenasParaFiltroProdutosLupa

  const [produtosAgregadoExpandido, setProdutosAgregadoExpandido] = useState<{
    [key: number]: boolean;
  }>(contexto.produtosAgregadoExpandido);

  useEffect(() => {
    setProdutosAgregadoExpandido(contexto.produtosAgregadoExpandido)
  }, [contexto.produtosAgregadoExpandido])

  const ProdutoAgregadoExpandidoFilhos = (CodigoProduto) => {
    const produtosAgregadosFilho = contexto.itens?.filter(
      (i) => i.CodigoProdutoAgregado == CodigoProduto
    );

    if (produtosAgregadosFilho) {
      return produtosAgregadosFilho
        .concat(
          produtosAgregadosFilho.map((p) =>
            ProdutoAgregadoSugeridoExpandidoFilhos(p.CodigoProduto)
          )
        )
        .concat(
          produtosAgregadosFilho.map((p) =>
            ProdutoAgregadoExpandidoFilhos(p.CodigoProduto)
          )
        );
    } else {
      return [];
    }
  };

  const toggleProdutoAgregadoExpandido = (CodigoProduto) => {
    const novosItensSugeridosExpandidos = {
      ...produtosAgregadoSugeridoExpandido,
    };
    const novosItensAgregadosExpandidos = { ...produtosAgregadoExpandido };

    if (CodigoProduto in novosItensAgregadosExpandidos) {
      delete novosItensAgregadosExpandidos[CodigoProduto];
      ProdutoAgregadoExpandidoFilhos(CodigoProduto).map((p) => {
        delete novosItensSugeridosExpandidos[p.CodigoProduto];
        delete novosItensAgregadosExpandidos[p.CodigoProduto];
      });
    } else {
      novosItensAgregadosExpandidos[CodigoProduto] =
        !produtosAgregadoExpandido[CodigoProduto];
    }
    setProdutosAgregadoSugeridoExpandido(novosItensSugeridosExpandidos);
    setProdutosAgregadoExpandido(novosItensAgregadosExpandidos);
  };

  const [
    produtosAgregadoSugeridoExpandido,
    setProdutosAgregadoSugeridoExpandido,
  ] = useState<{ [key: number]: boolean }>(contexto.produtosAgregadoSugeridoExpandido);

  useEffect(() => {
    setProdutosAgregadoSugeridoExpandido(contexto.produtosAgregadoSugeridoExpandido)
  }, [contexto.produtosAgregadoSugeridoExpandido])

  const ProdutoAgregadoSugeridoExpandidoFilhos = (CodigoProduto) => {
    const produtosAgregadosSugeridoFilho = contexto.itens?.filter(
      (i) => i.CodigoProdutoAgregadoSugerido == CodigoProduto
    );

    if (produtosAgregadosSugeridoFilho) {
      return produtosAgregadosSugeridoFilho
        .concat(
          produtosAgregadosSugeridoFilho.map((p) =>
            ProdutoAgregadoSugeridoExpandidoFilhos(p.CodigoProduto)
          )
        )
        .concat(
          produtosAgregadosSugeridoFilho.map((p) =>
            ProdutoAgregadoExpandidoFilhos(p.CodigoProduto)
          )
        );
    } else {
      return [];
    }
  };

  const toggleProdutoAgregadoSugeridoExpandido = (CodigoProduto) => {
    const novosItensSugeridosExpandidos = {
      ...produtosAgregadoSugeridoExpandido,
    };
    const novosItensAgregadosExpandidos = { ...produtosAgregadoExpandido };

    if (CodigoProduto in novosItensSugeridosExpandidos) {
      delete novosItensSugeridosExpandidos[CodigoProduto];
      ProdutoAgregadoSugeridoExpandidoFilhos(CodigoProduto).map((p) => {
        delete novosItensSugeridosExpandidos[p.CodigoProduto];
        delete novosItensAgregadosExpandidos[p.CodigoProduto];
      });
    } else {
      novosItensSugeridosExpandidos[CodigoProduto] =
        !produtosAgregadoSugeridoExpandido[CodigoProduto];
    }
    setProdutosAgregadoSugeridoExpandido(novosItensSugeridosExpandidos);
    setProdutosAgregadoExpandido(novosItensAgregadosExpandidos);
  };

  const produtoAgregadoOcultado = (item) =>
    !item.CodigoProdutoAgregado ||
    item.CodigoProdutoAgregado in produtosAgregadoExpandido;

  const produtoAgregadoSugeridoOcultado = (item) =>
    !item.CodigoProdutoAgregadoSugerido ||
    item.CodigoProdutoAgregadoSugerido in produtosAgregadoSugeridoExpandido;

  const valorDropdownAcoesRepetidoContext = useMemo(() => ({
    codigoProdutoComDropdownAberto,
    setCodigoProdutoComDropdownAberto,
  }), [codigoProdutoComDropdownAberto]);

  return (
    <DropdownAcoesRepetidoContext.Provider value={valorDropdownAcoesRepetidoContext}>
    <div style={{ position: "relative" }}>
      {contexto.chamadoParaInserirProdutoNoOrcamento && isSistemaOperacionalWindows() &&
      <TooltipMU
        id="GridItensPesquisaProdutos_TooltipMUAjuda"
        title={<>
          <div>- Mantenha o SHIFT pressionado e dê um duplo clique na linha do produto para adicioná-lo automaticamente ao orçamento.</div>
          <div style={{ marginTop: "6px" }}>- Mantenha a tecla <kbd>SHIFT</kbd> pressionada para rolar na horizontal</div>
        </>}
      >
        <span
          tabIndex={0}
          style={{ position: "absolute", top: "5px", right: "20px", cursor: "pointer", zIndex: 4 }}
          id="GridItensPesquisaProdutos_IconeAjuda"
        >
          <InfoIcon fontSize="large" style={{ color: "#409fff" }} />
        </span>
      </TooltipMU>
      }
      <div
        id="GridItensPesquisaProdutos_Div_Scroll"
        style={{
          overflowX: "scroll",
          marginRight: "10px",
        }}
      >
        <table className={clsx(estilosTabelas.tabela, "_w-full _border-collapse")}
          id="GridItensPesquisaProdutos_TabelaProdutos"
        >
          <TableHeadPesquisaProdutos />
          <tbody style={{ fontSize: fonteGradeOuHerdada(contexto.tamanhoFontePadrao) }}
            id="GridItensPesquisaProdutos_CorpoTabelaProdutos"
          >
            {contexto.itens
              ?.filter(produtoAgregadoOcultado)
              ?.filter(produtoAgregadoSugeridoOcultado)
              .map((i) => (
                <ItemPesquisaProduto
                  item={i}
                  onMostrarInformacoesProduto={() =>
                    contexto.onMostrarInformacoesProduto(i)
                  }
                  exibirIconeImagensProduto={(i.Imagens ?? []).length > 0}
                  onMostrarImagens={(classeElementoAncora) => contexto.onMostrarImagens(i.Codigo, classeElementoAncora)}
                  onMostrarTinta={() => contexto.onMostrarTinta(i)}
                  onProdutoAgregadoExpandido={() => {
                    contexto.onPesquisaProdutoAgregado(i)
                    toggleProdutoAgregadoExpandido(i.Codigo);
                  }}

                  onProdutoAgregadoSugeridoExpandido={() => {
                    contexto.onProdutoAgregadoExpandido(i)
                    toggleProdutoAgregadoSugeridoExpandido(i.Codigo);
                  }}
                  onProdutoSelecionado={() => {
                    contexto.onToggleProdutoSelecionado(i);
                  }}
                  selecionado={contexto.produtosSelecionados?.filter((c) => c.CodigoProduto == i.CodigoProduto).length == 1}
                  onConfirmaAlteracaoQuantidade={(quantidade) => {
                    contexto.onAlteracaoQuantidade(i, quantidade)
                  }
                  }
                  //exibirColunaQuantidade={exibirColunaQuantidade} // Cabeçalho da coluna Quantidade removido (itemPesquisaProduto_ColunaQuant)
                  itemInseridoNovo={i.AcaoProdutoRepetido == 0}
                  itemQuantidadeIncrementada={i.AcaoProdutoRepetido == 1}
                  key={i.CodigoProduto + i.CodigoProdutoAgregado + i.CodigoProdutoAgregadoSugerido}
                />
              ))}
          </tbody>
        </table>
      </div>
    </div>
    </DropdownAcoesRepetidoContext.Provider>
  );
};

export { GridItensPesquisaProdutos };
